import { render, staticRenderFns } from "./LeaderBoardContest.vue?vue&type=template&id=4145b01e&scoped=true"
import script from "./LeaderBoardContest.vue?vue&type=script&lang=js"
export * from "./LeaderBoardContest.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardContest.vue?vue&type=style&index=0&id=4145b01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145b01e",
  null
  
)

export default component.exports